


































































































































































import { Component, Vue } from "vue-property-decorator";
import {
  kbStatusOptions,
  kbJenisOptions
} from "@/constants/kebidananOptions";

@Component
export default class RiwayatObstetri extends Vue {
  kbJenisOptions = kbJenisOptions;
  showHphtPicker = false;
  showHplPicker = false;
  maxHphtDate = new Date().toISOString().substr(0, 10);
  riwObsStatus = false;

  obsRiwayat = null;
  obsG = null;
  obsP = null;
  obsA = null;
  obsAH = null;
  obsUsiaHamil = null;
  obsHpht = null;
  obsHpl = null;
  obsPalpasiLeo = null;
  obsTfu = null;
  obsTbj = null;
  obsHis = null;
  obsDjj = null;
  obsPanggul = null;
  obsVt = null;
  obsLla = null;
  obsTb = null;
  obsBb = null;
  obsKb = null;
  obsKbDescription = null;
  obsKbJenis: string | null = null;

  kbOptions = kbStatusOptions;

  get isUsingKb() {
    const id = (this.obsKb as any)?.id;
    return typeof id === "number" && id > 0;
  }

  get usiaKehamilanText() {
    const hpht = this.obsHpht ? new Date(this.obsHpht) : new Date();
    const diff = new Date().getTime() - hpht.getTime();

    const age = Math.floor(diff / (1000 * 60 * 60 * 24));

    this.obsUsiaHamil = age;

    const day = age % 7,
      week = (age - day) / 7;

    const dayText = day ? `${day} Hari` : "",
      weekText = week ? `${week} Minggu` : "";

    return [weekText, dayText].join(" ") ?? "-";
  }

  saveData() {
    //
  }
}
